import type {
  PaymentParams,
  TwoCreditCardsPaymentParams,
} from '@openeducation/pp-rn-shared-types';
import { PaymentMethod } from '@openeducation/pp-rn-shared-types';

export function convertToTwoCreditCardsParams(
  params: PaymentParams
): TwoCreditCardsPaymentParams {
  return {
    paymentMethod: PaymentMethod.TWO_CREDIT_CARDS,
    contractId: params.contractId,
    paymentInfoToken: params.paymentInfoToken,
    alternativePaymentGateway: params.alternativePaymentGateway,
    marketingTracking: params.marketingTracking,
    creditCards: {
      mainCard: {
        creditCardInfo: params.creditCardInfo!,
        billingAddress: params.billingAddress!,
        amount: params.creditCardInfo!.amount || 0,
        documentNumber: params.documentNumber!,
        documentType: params.documentType!,
      },
      secondCard: {
        creditCardInfo: params.creditCardInfo2!,
        billingAddress: params.billingAddress2!,
        documentNumber: params.documentNumber2!,
        documentType: params.documentType2!,
      },
    },
  };
}

export function shouldConvertToTwoCreditCards(params: PaymentParams): boolean {
  return params.paymentMethod === PaymentMethod.TWO_CREDIT_CARDS;
}
